import { render } from "./ProjectsTemplate.vue?vue&type=template&id=1146b0d5&scoped=true"
import script from "./ProjectsTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectsTemplate.vue?vue&type=script&lang=js"

import "./ProjectsTemplate.vue?vue&type=style&index=0&id=1146b0d5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1146b0d5"]])

export default __exports__